import { enClientPortalNotificationSettingsConstantsPages } from './Settings/constants'
import { enClientPortalNotificationSettingsContentPages } from './Settings/NotificationSettingsContent'
import { enClientPortalUserSettingsPagePages } from './Settings/UserSettingsPage'
import { enClientPortalUserSettingsSidebarPages } from './Settings/UserSettingsSidebar'

export const enClientPortalSettingsPages = {
    settings: {
        ...enClientPortalUserSettingsPagePages.settings,
        ...enClientPortalUserSettingsSidebarPages.settings,
        ...enClientPortalNotificationSettingsContentPages.settings,
        ...enClientPortalNotificationSettingsConstantsPages.settings,
    },
}
